import { Word } from "../../../../models/state/words/Words";

export function getId(word: Word) {
  return word.id;
}

export function getWord(word: Word) {
  return word.word;
}

export function getDefinition(word: Word) {
  return word.definition;
}

export function getModuleIds(word: Word) {
  return word.moduleIds;
}
